import { useTheme } from '@mui/styles';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    settingsButton: {
      alignItems: 'right',
    },
    container: {
      position: 'absolute',
      right: theme.spacing(4),
      top: theme.spacing(0.5),
    },
    containerBottom: {
      position: 'absolute',
      bottom: 0,
      width: '100%',
      textAlign: 'center',
      backgroundColor: 'rgba(230, 230, 230, 0.7)',
      zIndex: 2,
    },
    containerTop: {
      position: 'absolute',
      top: 0,
      width: '100%',
      backgroundColor: 'white',
      height: theme.spacing(3.5),
    },
    title: {
      flexGrow: 1,
      paddingRight: theme.spacing(1),
    },
    titleContent: {
      height: theme.spacing(2),
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(1),
    },
  };
};
